import React from 'react';
//import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { portalActions } from "store/portal-slice";

export const useUiState = () => {

    const dispatch = useDispatch();
    const isAppLoading = (state: any) => {
        dispatch(portalActions.updateIsAppLoading(state));
    }
    return { isAppLoading }
}